/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BasePromoBannerFragment} from '@amblique/contentful/app/contentful/fragments/promo-banner/base-promo-banner.fragment';
import {BasePromoBannerItemFragment} from '@amblique/contentful/app/contentful/fragments/promo-banner-item/base-promo-banner-item.fragment';

export const PromoBannerFragment = gql`
  ${BasePromoBannerFragment}
  ${BasePromoBannerItemFragment}

  fragment PromoBannerFragment on PromoBanner {
    ...BasePromoBannerFragment

    itemsCollection {
      items {
        __typename
        ... on PromoBannerItem {
          ...BasePromoBannerItemFragment
        }
      }
    }
    itemsCursorCollection {
      items {
        __typename
        ... on PromoBannerItem {
          ...BasePromoBannerItemFragment
        }
      }
    }
  }
`;
